import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.2476 8.6526C16.3644 8.3945 16.3091 8.09102 16.1086 7.89082C15.9082 7.69061 15.6046 7.63559 15.3467 7.75271L10.202 10.0886C10.0476 10.1587 9.92496 10.284 9.8581 10.4398L7.74698 15.3597C7.6373 15.6153 7.69429 15.9119 7.89088 16.1087C8.08747 16.3055 8.38406 16.3627 8.63977 16.2533L13.5657 14.1448C13.722 14.0779 13.8476 13.9549 13.9177 13.8L16.2476 8.6526ZM9.66778 14.3334L11.0044 11.2184L14.2625 9.73913L12.7873 12.9981L9.66778 14.3334Z"
        fill={colorValue}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2.25C6.61522 2.25 2.25 6.61522 2.25 12C2.25 17.3848 6.61522 21.75 12 21.75C17.3848 21.75 21.75 17.3848 21.75 12C21.75 6.61522 17.3848 2.25 12 2.25ZM3.61047 12C3.61047 7.36659 7.36659 3.61047 12 3.61047C16.6334 3.61047 20.3895 7.36659 20.3895 12C20.3895 16.6334 16.6334 20.3895 12 20.3895C7.36659 20.3895 3.61047 16.6334 3.61047 12Z"
        fill={colorValue}
      />
    </svg>
  );
};
